import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AiProps,
  NotesTranscriptionRequests,
} from 'src/requests/notes-transcription';

export const useAiTranscriptionMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: sendToAi, isLoading: isSendingToAi } = useMutation(
    (data: AiProps) => NotesTranscriptionRequests.sendToAi(data),
    {
      onSuccess(text) {
        queryClient.setQueriesData<{ text: string }>(['ai-action'], () => text);
        return text;
      },
    },
  );

  return { sendToAi, isSendingToAi };
};
